import { FC, useEffect, useState } from 'react'

declare global {
  interface Window {
    CookieScript?: {
      instance?: {
        show: () => void
      }
    }
  }
}

type CookiePreferencesLinkProps = {
  className?: string
}

const CookiePreferencesLink: FC<CookiePreferencesLinkProps> = ({
  className,
}) => {
  const [isAvailable, setIsAvailable] = useState(false)

  useEffect(() => {
    // Check if CookieScript is available, with a slight delay to allow script to load
    const checkCookieScript = () => {
      if (typeof window !== 'undefined' && window.CookieScript?.instance) {
        setIsAvailable(true)
      }
    }

    // Check immediately
    checkCookieScript()

    // Also check after a delay in case the script loads later
    const timeoutId = setTimeout(checkCookieScript, 1000)

    return () => clearTimeout(timeoutId)
  }, [])

  if (!isAvailable) {
    return null
  }

  const handleClick = () => {
    window.CookieScript?.instance?.show()
  }

  return (
    <a
      href='#'
      className={className}
      onClick={(e) => {
        e.preventDefault()
        handleClick()
      }}
    >
      Cookie Preferences
    </a>
  )
}

export default CookiePreferencesLink
